const Tagline = () => {
  return (
    <section className="tagline">
      <p>
        "If I'm not developing software, it's because I'm busy developing myself.
        If I can learn to be better, I can make machines learn faster."
      </p>
    </section>
  );
}

export default Tagline;